<template>
  <div>
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="$refs.edit.open()">新建</el-button>
    </div>
    <el-table
        v-loading="contentLoading"
        :data="tableData"
        row-key="id"
        border
        stripe
        :tree-props="{ children: 'children' }">
      <el-table-column prop="other" label="编号" width="120"/>
      <el-table-column prop="label" label="名称"/>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="$refs.edit.open(scope.row, 0)">新建</el-button>
          <el-button size="mini" type="primary" @click="$refs.edit.open(scope.row, 1)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <tool-type-edit ref="edit" @save-success="getData"/>
  </div>
</template>

<script>
  import ToolTypeEdit from "@/views/information/ToolManagement/ToolType/ToolTypeEdit";
  export default {
    components: {
      ToolTypeEdit,
    },
    data() {
      return {
        tableData: [],
        contentLoading: false,
      };
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", "toolTypes/tree")
          .then((res) => {
            if (res.success) {
              this.tableData = res.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "toolTypes", row.id).then((resp) => {
            if (resp.success) {
              this.getData();
              this.$message.success("删除成功");
            }
          });
        });
      },
    },
  };
</script>
